export const ZONE_NAME_SEPARATOR = ' - '
export const ZONE_NAME_TARGETING_KEY = 'zone_name'
